import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewConveniencePage } from '../new-company-pages/NewConveniencePage'

export default function ConveniencePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const convenienceID = urlParams?.convenience_id
    ? getIdWithPrefix(
        urlParams?.convenience_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Convenience]
      )
    : undefined

  return <NewConveniencePage convenienceID={convenienceID} />
}
